import { createStyles } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: 24,
    },
    banner: {
      backgroundColor: theme.colors.blue[0],
    },
    bannerInner: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      minHeight: 160,
      [theme.fn.largerThan('sm')]: {
        minHeight: 280,
      },
    },
    bannerHeader: {
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
      maxWidth: 552,
    },
    thumb: {
      display: 'flex',
      flexGrow: 0,
      justifyContent: 'center',
      width: 160,
      height: 160,
      borderRadius: '50%',
      backgroundImage:
        'linear-gradient(121.63deg, #FFFFFF 16.32%, rgba(255, 255, 255, 0) 61.5%)',
      [theme.fn.largerThan('sm')]: {
        position: 'absolute',
        right: 0,
        top: '25%',
        width: 360,
        height: 360,
      },
    },
    thumbImg: {
      maxWidth: 140,
      width: '100%',
      [theme.fn.largerThan('sm')]: {
        maxWidth: 240,
        maxHeight: 180,
        width: '100%',
        marginTop: '30px',
      },
    },
    group: {
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
    },
    body: {
      display: 'flex',
      flexDirection: 'column',
      gap: 32,
      [theme.fn.largerThan('sm')]: {
        gap: 48,
      },
      [theme.fn.smallerThan('sm')]: {
        '.health-tool-card': {
          borderBottom: `1px solid ${theme.colors.neutral[1]}`,
          '&:last-child': { borderBottom: 0 },
        },
      },
    },
    stickyNav: {
      transition: 'all 0.5s',
      '&.sticky': {
        boxShadow: '0px 4px 8px 0px #0000000A',
        backgroundColor: 'rgba(255, 255, 255, 0.64)',
        backdropFilter: 'blur(8px)',
        '.nav-menu': {
          borderBottom: 0,
        },
        '&.pinned': {
          paddingTop: '55px',
        },
      },
      paddingTop: 0,
      [theme.fn.largerThan('sm')]: {
        position: 'sticky',
        top: '-1px',
        zIndex: 1,
        paddingTop: '55px',
      },
    },
    accControl: {
      borderRadius: 4,
      color: theme.fn.primaryColor(),
      border: `1px solid ${theme.fn.primaryColor()}`,
      padding: `12px 16px`,
      '&[aria-expanded="true"]': {
        '.see-more': {
          display: 'none',
        },
      },
      '&[aria-expanded="false"]': {
        '.see-less': {
          display: 'none',
        },
      },
      [theme.fn.smallerThan('sm')]: {
        justifyContent: 'center',
      },
      [theme.fn.largerThan('sm')]: {
        width: 'auto',
      },
    },
    accLabel: {
      padding: 0,
      color: theme.fn.primaryColor(),
      flex: 'none',
    },
    accItem: {
      border: 0,
    },
    accContent: {
      padding: 0,
    },
    accPanel: {
      paddingBottom: 24,
    },
    accChevron: {
      marginLeft: 4,
      [theme.fn.smallerThan('sm')]: {
        flex: 'none',
      },
    },
  }
})
